import type { OrderItem } from "../../types";

/**
 * HA-600-2 — the till's lines with each SENT line's routing taken from a send's answer: its queue and
 * course (taken at send, D-HA-28 28-2) and its prep time (AC6). Only those fields: the till keeps its
 * own copy of the order, so a line added while the request was out, or an edit made meanwhile, is
 * not lost to the answer.
 */
export function withSentRouting(
	local: OrderItem[],
	server: OrderItem[],
): OrderItem[] {
	const sent = new Map(
		server.filter((i) => i.sentToKitchen).map((i) => [i.id, i]),
	);

	return local.map((item) => {
		const answer = sent.get(item.id);
		return answer
			? {
					...item,
					queueId: answer.queueId,
					courseId: answer.courseId,
					preparationTime: answer.preparationTime,
					sentToKitchen: true,
				}
			: item;
	});
}
